import React from 'react';
import { OverflowMenuItem, OverflowMenu } from '../Carbon';
import { language } from '../../services/LanguageService';
/**
 * React Component
 *
 * The AsperaOverflow provides a simple way to get carbon OverflowMenuItems.
 * A single onClick is triggered when any are selected, and returns the menu item.
 * This takes in an array of items and returns the OverflowMenuItems and the user event
 *
 * @example
 * ```javascript
 * <AsperaOverflow menuItems{[]} onClick={() => {}} />
 * ```
 */
export class AsperaOverflow extends React.Component {
    constructor() {
        super(...arguments);
        /** Menu options to indicate no items available */
        this.noItemsFallback = [
            {
                itemText: language.get('lists.noItemsAvailable'),
                disabled: true,
            },
        ];
        this.handleClick = (item, event) => {
            const { onClick } = this.props;
            if (typeof onClick === 'function') {
                onClick(item, event);
            }
            if (typeof item.onClick === 'function') {
                item.onClick(item, event);
            }
        };
    }
    render() {
        const { menuItems, menuOptions } = this.props;
        const itemsToUse = menuItems.length ? menuItems.filter(item => !item.hidden) : this.noItemsFallback;
        menuOptions.className = menuOptions.className ? `aspera-overflow ${menuOptions.className}` : 'aspera-overflow';
        if (typeof menuOptions.flipped !== 'boolean') {
            menuOptions.flipped = language.leftRightStyle;
        }
        if (!itemsToUse.length) {
            return null;
        }
        return (React.createElement(OverflowMenu, Object.assign({ iconDescription: language.get('lists.viewOptions'), "aria-label": language.get('lists.viewOptions') }, menuOptions, { "data-auto": "overflow-menu" }), itemsToUse.map((item, index) => {
            return (React.createElement(OverflowMenuItem, { key: index, "data-auto": `overflow-item-${item.itemText}`, className: `${item.className ? item.className : ''}`, itemText: item.itemText, disabled: item.disabled || false, onClick: (e) => {
                    this.handleClick(item, e);
                } }));
        })));
    }
}
